const ordnumber = Math.random() * 10000000000000;
const sscUrl = (document.location.protocol === 'https:' ? 'https://' : ' http://') + 'trkn.us/pixel/conv/ppt=21361;g=nearpeer_lp;gid=51166;ord=' + ordnumber + ';v=120';
const x = document.createElement('IMG');
x.setAttribute('src', sscUrl);
x.setAttribute('alt', '');
x.setAttribute('width', '1');
x.setAttribute('height', '1');
document.body.appendChild(x);
